import { fromJS, List, Map } from 'immutable';

import {
  LOADED_HARVCO_TAGS_SUCCESS,
  INSERT_HARVCO_TAG_ROW,
  CHANGE_HARVCO_TAG_ROW_MODE,
  CHANGE_HARVCO_TAG_ROW,
  DELETED_HARVCO_TAG_ROW_SUCCESS,
  SAVED_HARVCO_TAGS_SUCCESS,
} from '../../actions/eproject/harvcoTag';
import { INSERT_INDUSTRY_ROW, CHANGE_INDUSTRY_ROW_MODE } from '../../actions/eproject/industry';
import { RESET_ALL_ROW_TO_VIEW_MODE } from '../../actions/eproject/main';
import config from '../../config';
import { spy, setIn, isChanged } from '../../utils/ChangeSpy';
import { clearDirty } from './common';

const FIELDS_TO_SPY = ['tag'];
const defaultState = fromJS([]);

export default function(state = defaultState, action) {
  switch (action.type) {
    case LOADED_HARVCO_TAGS_SUCCESS:
      return getList(action.response, 'harvcoTags');

    case INSERT_HARVCO_TAG_ROW:
      return insert(state);

    case CHANGE_HARVCO_TAG_ROW_MODE:
      return switchToEdit(state, action);

    case CHANGE_HARVCO_TAG_ROW:
      return update(state, action);

    case DELETED_HARVCO_TAG_ROW_SUCCESS:
      return state;

    case RESET_ALL_ROW_TO_VIEW_MODE:

    // fallthrough
    case INSERT_INDUSTRY_ROW:

    // fallthrough
    case CHANGE_INDUSTRY_ROW_MODE:
      return switchToView(state);

    case SAVED_HARVCO_TAGS_SUCCESS:
      return clearDirty(state);

    default:
      return state;
  }
}

/**
 * Get a list from response.
 *
 * @param response {Object} Response.
 */
function getList(response) {
  if (response.status === 'success') {
    return fromJS(
      response.data.harvcoTags.map((harvco, index) =>
        Map(
          spy(
            {
              index,
              ...harvco,
              origin: harvco.tag,
              mode: config.VIEW_MODE,
              dirty: false,
            },
            ['tag'],
          ),
        ),
      ),
    );
  }

  return List();
}

/**
 * Insert a new row.
 *
 * @param state {Immutable.List} State.
 */
function insert(state) {
  return resetToView(state).push(createEmptyRow(state.size));
}

/**
 * Reset all items to view mode.
 *
 * @param state {Immutable.List} State.
 */
function resetToView(state) {
  return state.map(a => a.set('mode', config.VIEW_MODE));
}

/**
 * Get harvco tags from response.
 *
 * @param state {Immutable.Map} State.
 * @param action {Object} Action object.
 * @return {Immutable.List} Approvals list.
 */
function update(state, action) {
  const { index, name, value } = action;
  const key = state.findKey(a => a.get('index') === index);

  if (key !== undefined && key >= 0) {
    let item = setIn(state.get(key), name, value);

    item = item.set(
      'dirty',
      FIELDS_TO_SPY.reduce((changed, value) => changed || isChanged(item.get(value)), false),
    );

    return state.set(key, item);
  }

  return state;
}

/**
 * Switch all rows to view mode.
 *
 * @param state {Immutable.Map} State.
 * @param action {Object} Action object.
 * @return {Immutable.List}
 */
export function switchToEdit(state, action) {
  const newState = switchToView(state);
  const { index } = action;
  const key = newState.findKey(k => k.get('index') === index);

  if (key !== undefined && key >= 0) {
    return newState.setIn([key, 'mode'], config.EDIT_MODE);
  }
}

/**
 * Switch all rows to view mode.
 *
 * @param list {Immutable.List} List.
 */
export function switchToView(list) {
  return list.map(item => item.set('mode', config.VIEW_MODE));
}

/**
 * Create an empty row and set it to edit mode.
 */
function createEmptyRow(index) {
  return spy(
    fromJS({
      index,
      id: -1,
      tag: '',
      mode: config.EDIT_MODE,
      dirty: false,
    }),
    FIELDS_TO_SPY,
  );
}
